//deps
import { useState } from "react";

//helpers
import { areElementsIntersecting } from "@core-ui/helpers/Dom";

//hooks
import { useEffectOnce } from "@core-ui/hooks/UseEffectOnce";
import { useMountedRef } from "@core-ui/hooks/UseMountedRef";

/*
This hook accepts ref of 2 elements as params and check
if the elements are intersecting after mutation happen in 1 element
*/
export const useMutationObserver = (
    elementIntersectingWithMutatingElementRef: React.RefObject<HTMLElement>,
    mutationElementRef: React.RefObject<HTMLElement>,
    options: MutationObserverInit,
    mutationType: MutationRecordType,
): boolean => {
    const [isIntersecting, setIsIntersecting] = useState(false);
    const isMountedRef = useMountedRef();

    useEffectOnce(() => {
        const observer = new MutationObserver(mutationsList => {
            mutationsList.forEach(mutation => {
                if (mutation.type === mutationType && isMountedRef.current) {
                    if (
                        elementIntersectingWithMutatingElementRef.current &&
                        mutationElementRef.current &&
                        areElementsIntersecting(
                            elementIntersectingWithMutatingElementRef.current,
                            mutationElementRef.current,
                        )
                    ) {
                        setIsIntersecting(true);
                    } else {
                        setIsIntersecting(false);
                    }
                }
            });
        });
        if (mutationElementRef.current) {
            observer.observe(mutationElementRef.current, options);
        }
        return (): void => observer.disconnect();
    });

    return isIntersecting;
};
